Vue.component('teamleaderboard', {
    template: templates.teamLeaderBoard,
    data() {
      return {
        model: {
          teams: [],
          top: [],
          medals: [],
          isLoggedIn: false,
          selectedOption: 0,
          options: [
            { value: 'Squad', name: 'Squad' },
            { value: '2v2', name: '2v2' },
            { value: '3v3', name: '3v3' },
            { value: '4v4', name: '4v4' }
          ],
          memberCount: 4
        }
      }
    },
    mounted() {
      const c = this;
      c.get();
      c.getMedals();
  
      $('[data-view="viewer-dashboard"]').on(
        'click',
        '[data-component="team-leaderboard"] .medal',
        function (e) {
          c.show($(this).clone());
        }
      );
  
      $('[data-view="viewer-dashboard"]').on(
        'click',
        '.view-element',
        function () {
          c.hide();
        }
      );
    },
    methods: {
      async get() {
        const c = this;
   
        try {
            const response = await userService.getTeamLeaderboard();
            c.model.teams = response.data;
          
            // Filter out teams with null or empty members
            c.model.teams = c.model.teams.filter(team => 
              team.members && team.members.length > 0 && 
              team.members.every(memberArray => memberArray && memberArray.length > 0)
            );
    
            // Create an array of promises for fetching Twitch user info
            const memberPromises = [];
    
            c.model.teams.forEach((team) => {
                team.members.forEach((memberArray, memberIndex) => {
                    const member = memberArray[0];
                    const promise = new Promise((resolve) => {
                        c.getCurrentTwitchInfo(member, member.twitchId, function(user) {
                            if (user) {
                                team.members[memberIndex] = {
                                    ...member,
                                    twitchDisplayName: user.twitchDisplayName,
                                    twitchProfileImage: user.twitchProfileImage
                                };
                            }
                            resolve(); 
                        });
                    });
                    memberPromises.push(promise);
                });
            });
    
            await Promise.all(memberPromises);
    
            const [first, second, third] = c.model.teams.slice(0, 3);
            c.model.top = [second, first, third];
            c.model.isLoggedIn = true;
        } catch (error) {
            console.error("Error fetching team leaderboard:", error);
        }
    },
      getMedals() {
        const c = this;
  
        medalService
          .get()
          .then(function (response) {
            //medals = response.data;
            for (let medal of response.data) {
              medal.image = `${root}/images/medals/${medal.id}.png`;
            }
            c.model.medals = response.data;
          })
          .catch(function (error) {});
      },
      show($element) {
        const c = this;
        let id = $element.data('id');
        let video = `/videos/medals/${id}.webm`;
        let name = '';
        let description = '';
  
        for (let medal of c.model.medals) {
          if (medal.id == id) {
            name = medal.name;
            description = medal.description;
            break;
          }
        }
  
        //let description = $card.find('.bottom > div:first-of-type').data('description');
        $element.find('.description').attr('class', '');
  
        let html = `<div class="medal">`;
        html += `<div class="video"></div>`;
        html += `<p title="${name}">${name}</p>`;
        html += `<p title="${description}" class="">${description}</p>`;
        html += `</div>`;
  
        let $popup = $(html);
        $popup.find('.video').append($element);
  
        var testEl = document.createElement('video'),
          webm;
        if (testEl.canPlayType) {
          // Check for Webm support
          webm = '' !== testEl.canPlayType('video/webm; codecs="vp8, vorbis"');
          if (webm) {
            $popup
              .find('img')
              .replaceWith(
                `<video src="${video}" class="video-overlay__video" loop muted autoplay playsinline></video>`
              );
          }
        }
  
        $('.view-element > div').append($popup);
        $('.view-element').addClass('is-above').addClass('is-visible');
      },
      hide() {
        $('.view-element').removeClass('is-visible');
        setTimeout(function () {
          $('.view-element').removeClass('is-above');
          $('.view-element > div').html('');
        }, 300);
      },
      getCurrentTwitchInfo( udata, data, callback) {
        const c = this;
        return new Promise((resolve) => {
          twitchAPI.getUsersById([{ twitchId: data }], function(userData) {
            if (userData && userData.length > 0) {
              let user = {
                twitchId: userData[0].id,
                twitchDisplayName: userData[0].display_name,
                twitchProfileImage: userData[0].profile_image_url
              };
              callback(user); 
              resolve(user);
            } else {
            
              const defaultUser  = {
                  twitchId: udata.twitchId, 
                  twitchDisplayName: udata.twitchDisplayName,
                  twitchProfileImage: udata.twitchProfileImage 
              };
              console.log(defaultUser)
              callback(defaultUser); 
              resolve(defaultUser); 
            }
          });
        });
      },
      async getSelectedOption(){
        const c = this;
        c.model.isLoggedIn = false
        if(c.model.selectedOption === '2v2'){
          c.model.memberCount = 2;
        }
        else if(c.model.selectedOption === '3v3'){
          c.model.memberCount = 3;
        }
        else if(c.model.selectedOption === '4v4'){
          c.model.memberCount = 4;
        }
        else{
          c.get();
          return;
        }
        
        try {
          const response = await userService.getSelectedTeamLeaderboard(c.model.selectedOption);
          c.model.teams = response.data;
        
          // Filter out teams with null or empty members
          c.model.teams = c.model.teams.filter(team => 
            team.members && team.members.length > 0 && 
            team.members.every(memberArray => memberArray && memberArray.length > 0)
          );
  
          // Create an array of promises for fetching Twitch user info
          const memberPromises = [];
  
          c.model.teams.forEach((team) => {
              team.members.forEach((memberArray, memberIndex) => {
                  const member = memberArray[0];
                  const promise = new Promise((resolve) => {
                      c.getCurrentTwitchInfo(member, member.twitchId, function(user) {
                          if (user) {
                              team.members[memberIndex] = {
                                  ...member,
                                  twitchDisplayName: user.twitchDisplayName,
                                  twitchProfileImage: user.twitchProfileImage
                              };
                          }
                          resolve(); 
                      });
                  });
                  memberPromises.push(promise);
              });
          });
  
          await Promise.all(memberPromises);
  
          const [first, second, third] = c.model.teams.slice(0, 3);
          c.model.top = [second, first, third];
          c.model.isLoggedIn = true;
        } catch (error) {
            console.error("Error fetching team leaderboard:", error);
        }

      }
    },
  });